export default __webpack_public_path__ + "static/media/y.1a4daab4.mp3";